<script setup lang="ts">
import UserPartsCombination from '@/components/userManagement/UserPartsCombination.vue'
</script>

<template>
  <div class="user-management">
    <UserPartsCombination></UserPartsCombination>
  </div>
</template>

<style lang="scss" scoped>
.user-management {
  margin: 0.5%;
}
</style>
